import React, { useMemo } from "react";

import * as HoverCard from "@radix-ui/react-hover-card";
import {
  hoverCardChildrenContainer,
  hoverCardItemContent,
  hoverCardItemLabel,
  hoverCardSectionContent,
  hoverCardTitle,
} from "./sidebarHoverCard.css";
import { MODAL_ROOT_ID } from "constants/ui";
import { IS_CLIENT } from "lib/config";

export type SidebarHoverCardProps = {
  title: string;
  children?: React.ReactNode;
  trigger: React.ReactNode;
};

const HOVER_CARD_OFFSET = 8;

export const SidebarHoverCard = ({ title, children, trigger }: SidebarHoverCardProps) => {
  const hasChildren = React.Children.count(children) > 0;
  const modalRoot = useMemo(() => (IS_CLIENT ? document.getElementById(MODAL_ROOT_ID) : null), []);

  return (
    <HoverCard.Root openDelay={50} closeDelay={100}>
      <HoverCard.Trigger asChild>{trigger}</HoverCard.Trigger>
      <HoverCard.Portal container={modalRoot}>
        <>
          {hasChildren ? (
            <HoverCard.Content
              side="right"
              align="start"
              sideOffset={HOVER_CARD_OFFSET}
              className={hoverCardSectionContent}
            >
              <div className={hoverCardTitle}>{title}</div>
              <div className={hoverCardChildrenContainer} role="menu">
                {children}
              </div>
            </HoverCard.Content>
          ) : (
            <HoverCard.Content
              side="right"
              align="start"
              sideOffset={HOVER_CARD_OFFSET}
              className={hoverCardItemContent}
            >
              <div className={hoverCardItemLabel}>{title}</div>
            </HoverCard.Content>
          )}
        </>
      </HoverCard.Portal>
    </HoverCard.Root>
  );
};
